// Nid apis from auth service
export const nidApi = 'nid/voter-details-with'
export const paymentOnlineApi = 'portal/public-panel/donation-service/payment-online'
export const paymentReceiptApi = 'portal/public-panel/donation-service/payment-receipt'
export const paymentUpdateStatusApi = 'portal/public-panel/donation-service/'

// hospital service public panel
export const portalHospitalServiceReportApi = 'portal/public-panel/hospital-service/report'
export const portalHosDisabilityServiceSearchApi = 'portal/public-panel/hospital-service/search'
export const portalSamitiFormListApi = 'portal/configuration/samiti-form/list'
export const portalSmaitiApplicationNidApi = 'portal/configuration/samiti-form/nid-search'
export const portalHospitalApi = 'portal/configuration/samiti-form/hospital-list'
export const portalSamitiFormStoreApi = 'portal/configuration/samiti-form/portal-store'
export const portalHospitaListApi = 'portal/configuration/samiti-form/portal-hospital-list'
export const portalTherapyCenterList = 'portal/consultancy-therapy-center/therapy-center/list'
export const hospitaListApi = 'configuration/hospital/list'
export const portalHospitalContactList = 'portal/consultancy-therapy-center/therapy-center/hospital-info-details'
export const portalPatientGetRegisteredPatientApi = 'portal/consultancy-therapy-center/patient-registration/get-registered-patient'
export const portalPatientRegistrationStoreApi = 'portal/consultancy-therapy-center/patient-registration/store'
export const portalPatientRegistrationUpdateApi = 'portal/consultancy-therapy-center/patient-registration/update'
export const patientNewFormNoApi = 'portal/configuration/patient-registration/generate-new-form-no'
export const portalHospitalDepartmentApi = 'portal/configuration/patient-registration/hospital-department-list'
export const portalHospitalWardApi = 'portal/configuration/patient-registration/hospital-ward-list'
export const portalHospitalBedApi = 'portal/configuration/patient-registration/hospital-bed-list'
export const portalHospitalSubServiceTypeApi = 'portal/configuration/patient-registration/hospital-sub-service-type-list'
export const portalHosPatientRegistrationStoreApi = 'portal/configuration/patient-registration/store'

// hospital service public panel
export const hospitalServiceDonationStoreApi = 'portal/public-panel/hospital-service/donation/store'
